/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_View_TitleInputs */

const en_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table view`)
};

const fr_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue en tableau`)
};

const de_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabellenansicht`)
};

const it_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista tabella`)
};

const ru_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Табличный вид`)
};

const es_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de tabla`)
};

const zh_cn2_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表格视图`)
};

const ja_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーブルビュー`)
};

const hi_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेबल दृश्य`)
};

const pt_pt2_speakers_table_view_title = /** @type {(inputs: Speakers_Table_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização em tabela`)
};

/**
* | output |
* | --- |
* | "Table view" |
*
* @param {Speakers_Table_View_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_view_title = /** @type {((inputs?: Speakers_Table_View_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_View_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_table_view_title(inputs)
	if (locale === "de") return de_speakers_table_view_title(inputs)
	if (locale === "it") return it_speakers_table_view_title(inputs)
	if (locale === "ru") return ru_speakers_table_view_title(inputs)
	if (locale === "es") return es_speakers_table_view_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_table_view_title(inputs)
	if (locale === "ja") return ja_speakers_table_view_title(inputs)
	if (locale === "hi") return hi_speakers_table_view_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_table_view_title(inputs)
	return en_speakers_table_view_title(inputs)
});